<template>
  <b-dropdown-item @click.stop="seeAllInitiatives" :disabled="disabled">
    See {{ type }} Initiatives
  </b-dropdown-item>
</template>

<script>
import { goalsTabIds } from '@/constants/goals'
import { InitiativeFieldId, Operator } from '@/constants/initiative/filter'
import serializeFilterOp from '@/utils/initiative/serializeFilterOp'
import { getTeamPageRouteConfig } from '@/utils/navigationConfigs'
import { BDropdownItem } from 'bootstrap-vue'
import { BOARD_VIEW, DEFAULT_GROUP_BY } from '@/constants/initiative'

/**
 * This component renders a dropdown option to See All Initiative of KR/Goal
 * On click of option, user is taken to Goals page with Initiatives Tab selected and related KRs are populated in filter by default
 */
export default {
  name: 'AllInitiativesNavOption',
  props: ['type', 'kr', 'goal', 'disabled'],
  components: {
    BDropdownItem
  },
  methods: {
    seeAllInitiatives() {
      const krIds = this.goal.keyResults.map(kr => kr.id)
      const krsToShow = this.kr ? [this.kr.id] : krIds
      const location = getTeamPageRouteConfig({
        orgId: this.goal.organizationId,
        entity: goalsTabIds.initiatives,
        teamId: this.goal.teamId,
        query: {
          filterOp: [serializeFilterOp(InitiativeFieldId.KEY_RESULT, Operator.IN, krsToShow)],
          view: BOARD_VIEW,
          groupBy: DEFAULT_GROUP_BY[BOARD_VIEW]
        }
      })
      this.$router.push(location)
    }
  }
}
</script>

<style scoped></style>
